import type { CSSProperties } from 'react';
import { useId } from 'react';

import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { useTheme } from 'styled-components';

type GeneralApprovalIconProps = IconComponentBaseProps;

export const GeneralApprovalIcon = ({ width = 24, height = 24, fill, className }: GeneralApprovalIconProps) => {
  const theme = useTheme();
  const maskId = useId();
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask id={maskId} style={maskStyle} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M6.30775 20.731C5.81058 20.731 5.385 20.554 5.031 20.2C4.677 19.846 4.5 19.4204 4.5 18.9233V15.5003C4.5 14.9951 4.675 14.5675 5.025 14.2175C5.375 13.8675 5.80258 13.6925 6.30775 13.6925H17.6923C18.1974 13.6925 18.625 13.8675 18.975 14.2175C19.325 14.5675 19.5 14.9951 19.5 15.5003V18.9233C19.5 19.4204 19.323 19.846 18.969 20.2C18.615 20.554 18.1894 20.731 17.6923 20.731H6.30775ZM6.923 17.231H17.077C17.3385 17.231 17.5577 17.1425 17.7345 16.9655C17.9115 16.7887 18 16.5695 18 16.308V16.1155C18 15.8643 17.909 15.6477 17.727 15.4655C17.5448 15.2835 17.3282 15.1925 17.077 15.1925H6.923C6.67183 15.1925 6.45517 15.2835 6.273 15.4655C6.091 15.6477 6 15.8643 6 16.1155V16.308C6 16.5695 6.0885 16.7887 6.2655 16.9655C6.44233 17.1425 6.6615 17.231 6.923 17.231ZM11.2615 12.6773L7.9365 8.08876C7.79933 7.89126 7.70158 7.67709 7.64325 7.44626C7.58492 7.21543 7.57242 6.98084 7.60575 6.74251C7.78142 5.61834 8.26442 4.69434 9.05475 3.97051C9.84525 3.24684 10.827 2.88501 12 2.88501C13.173 2.88501 14.1548 3.24684 14.9453 3.97051C15.7356 4.69434 16.2186 5.61834 16.3943 6.74251C16.4276 6.98084 16.4151 7.21543 16.3568 7.44626C16.2984 7.67709 16.2007 7.89126 16.0635 8.08876L12.737 12.6773C12.5572 12.9284 12.311 13.054 11.9985 13.054C11.6858 13.054 11.4402 12.9284 11.2615 12.6773ZM12 11.5175L15 7.38501C15 6.55168 14.7083 5.84334 14.125 5.26001C13.5417 4.67668 12.8333 4.38501 12 4.38501C11.1667 4.38501 10.4583 4.67668 9.875 5.26001C9.29167 5.84334 9 6.55168 9 7.38501L12 11.5175Z"
          fill={fill || theme.mantineColors.cyan[7]}
        />
      </g>
    </svg>
  );
};

const maskStyle: CSSProperties = {
  maskType: 'alpha',
};
